// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f339f04d","453":"27146c67","732":"0ce5c158","762":"40001c74","977":"448e2547"}[chunkId] + ".chunk.js";
};